module.exports = __webpack_public_path__ + "img/warning.14c56bd5.svg";